<template>
  <div id="app">
    <EducationalCalculator :min="0" :max="100" :step="5" />
  </div>
</template>

<script>
import EducationalCalculator from "./components/EducationalCalculator.vue";

export default {
  name: "App",
  components: {
    EducationalCalculator,
  },
};
</script>

<style>
#app {
}
</style>
